import React, { Component } from 'react';
import PageLoader from "../../atom/loader/pageLaoder";
import { connect } from 'react-redux';

class AllPage extends Component {
    componentDidMount() {
        let arnCode = localStorage.getItem('ARNCode')
        console.log("checking at line 7: ", this.props)
        let mainPath2 = `${process.env.REACT_APP_REPORT_MF_SERVER_PATH}`
        let localpath = "http://localhost:8080"
        // let arnCode = (this.props.userDetails && this.props.userDetails.employee_ID) ? this.props.userDetails.employee_ID : ""
        let newURL = `${mainPath2}ditauth/getauth?distype=ALL&arnCode=${arnCode}`
        console.log(newURL, "newURL")
        window.location.href = newURL
    }

    render() {
        return (
            <PageLoader />
        );
    }
}

// const mapStateToProps = state => ({
//     userDetails: state.pmsUser.pmsState,
// })
// export default connect(mapStateToProps)(PMSPage);

export default AllPage;
